import Logo1 from './images/LOGO_draw_on-loop 2_00001.png';
import Logo2 from './images/LOGO_draw_on-loop 2_00002.png';
import Logo3 from './images/LOGO_draw_on-loop 2_00003.png';
import Logo4 from './images/LOGO_draw_on-loop 2_00004.png';
import Logo5 from './images/LOGO_draw_on-loop 2_00005.png';
import Logo6 from './images/LOGO_draw_on-loop 2_00006.png';
import Logo7 from './images/LOGO_draw_on-loop 2_00007.png';
import Logo8 from './images/LOGO_draw_on-loop 2_00008.png';
import Logo9 from './images/LOGO_draw_on-loop 2_00009.png';
import Logo10 from './images/LOGO_draw_on-loop 2_00010.png';
import Logo11 from './images/LOGO_draw_on-loop 2_00011.png';
import Logo12 from './images/LOGO_draw_on-loop 2_00012.png';
import Logo13 from './images/LOGO_draw_on-loop 2_00013.png';
import Logo14 from './images/LOGO_draw_on-loop 2_00014.png';
import Logo15 from './images/LOGO_draw_on-loop 2_00015.png';
import Logo16 from './images/LOGO_draw_on-loop 2_00016.png';
import Logo17 from './images/LOGO_draw_on-loop 2_00017.png';
import Logo18 from './images/LOGO_draw_on-loop 2_00018.png';
import Logo19 from './images/LOGO_draw_on-loop 2_00019.png';
import Logo20 from './images/LOGO_draw_on-loop 2_00020.png';
import Logo21 from './images/LOGO_draw_on-loop 2_00021.png';
import Logo22 from './images/LOGO_draw_on-loop 2_00022.png';
import Logo23 from './images/LOGO_draw_on-loop 2_00023.png';
import Logo24 from './images/LOGO_draw_on-loop 2_00024.png';
import Logo25 from './images/LOGO_draw_on-loop 2_00025.png';
import Logo26 from './images/LOGO_draw_on-loop 2_00026.png';
import Logo27 from './images/LOGO_draw_on-loop 2_00027.png';
import Logo28 from './images/LOGO_draw_on-loop 2_00028.png';
import Logo29 from './images/LOGO_draw_on-loop 2_00029.png';
import Logo30 from './images/LOGO_draw_on-loop 2_00030.png';
import Logo31 from './images/LOGO_draw_on-loop 2_00031.png';
import Logo32 from './images/LOGO_draw_on-loop 2_00032.png';
import Logo33 from './images/LOGO_draw_on-loop 2_00033.png';
import Logo34 from './images/LOGO_draw_on-loop 2_00034.png';
import Logo35 from './images/LOGO_draw_on-loop 2_00035.png';
import Logo36 from './images/LOGO_draw_on-loop 2_00036.png';
import Logo37 from './images/LOGO_draw_on-loop 2_00037.png';
import Logo38 from './images/LOGO_draw_on-loop 2_00038.png';
import Logo39 from './images/LOGO_draw_on-loop 2_00039.png';
import Logo40 from './images/LOGO_draw_on-loop 2_00040.png';
import Logo41 from './images/LOGO_draw_on-loop 2_00041.png';
import Logo42 from './images/LOGO_draw_on-loop 2_00042.png';
import Logo43 from './images/LOGO_draw_on-loop 2_00043.png';
import Logo44 from './images/LOGO_draw_on-loop 2_00044.png';
import Logo45 from './images/LOGO_draw_on-loop 2_00045.png';
import Logo46 from './images/LOGO_draw_on-loop 2_00046.png';
import Logo47 from './images/LOGO_draw_on-loop 2_00047.png';
import Logo48 from './images/LOGO_draw_on-loop 2_00048.png';
import Logo49 from './images/LOGO_draw_on-loop 2_00049.png';
import Logo50 from './images/LOGO_draw_on-loop 2_00050.png';
import Logo51 from './images/LOGO_draw_on-loop 2_00051.png';
import Logo52 from './images/LOGO_draw_on-loop 2_00052.png';
import Logo53 from './images/LOGO_draw_on-loop 2_00053.png';
import Logo54 from './images/LOGO_draw_on-loop 2_00054.png';
import Logo55 from './images/LOGO_draw_on-loop 2_00055.png';
import Logo56 from './images/LOGO_draw_on-loop 2_00056.png';
import Logo57 from './images/LOGO_draw_on-loop 2_00057.png';
import Logo58 from './images/LOGO_draw_on-loop 2_00058.png';
import Logo59 from './images/LOGO_draw_on-loop 2_00059.png';
import Logo60 from './images/LOGO_draw_on-loop 2_00060.png';
import Logo61 from './images/LOGO_draw_on-loop 2_00061.png';
import Logo62 from './images/LOGO_draw_on-loop 2_00062.png';
import Logo63 from './images/LOGO_draw_on-loop 2_00063.png';
import Logo64 from './images/LOGO_draw_on-loop 2_00064.png';
import Logo65 from './images/LOGO_draw_on-loop 2_00065.png';
import Logo66 from './images/LOGO_draw_on-loop 2_00066.png';
import Logo67 from './images/LOGO_draw_on-loop 2_00067.png';
import Logo68 from './images/LOGO_draw_on-loop 2_00068.png';
import Logo69 from './images/LOGO_draw_on-loop 2_00069.png';
import Logo70 from './images/LOGO_draw_on-loop 2_00070.png';
import Logo71 from './images/LOGO_draw_on-loop 2_00071.png';
import Logo72 from './images/LOGO_draw_on-loop 2_00072.png';
import Logo73 from './images/LOGO_draw_on-loop 2_00073.png';
import Logo74 from './images/LOGO_draw_on-loop 2_00074.png';
import Logo75 from './images/LOGO_draw_on-loop 2_00075.png';
import Logo76 from './images/LOGO_draw_on-loop 2_00076.png';
import Logo77 from './images/LOGO_draw_on-loop 2_00077.png';
import Logo78 from './images/LOGO_draw_on-loop 2_00078.png';
import Logo79 from './images/LOGO_draw_on-loop 2_00079.png';
import Logo80 from './images/LOGO_draw_on-loop 2_00080.png';
import Logo81 from './images/LOGO_draw_on-loop 2_00081.png';
import Logo82 from './images/LOGO_draw_on-loop 2_00082.png';
import Logo83 from './images/LOGO_draw_on-loop 2_00083.png';
import Logo84 from './images/LOGO_draw_on-loop 2_00084.png';
import Logo85 from './images/LOGO_draw_on-loop 2_00085.png';
import Logo86 from './images/LOGO_draw_on-loop 2_00086.png';
import Logo87 from './images/LOGO_draw_on-loop 2_00087.png';
import Logo88 from './images/LOGO_draw_on-loop 2_00088.png';
import Logo89 from './images/LOGO_draw_on-loop 2_00089.png';
import Logo90 from './images/LOGO_draw_on-loop 2_00090.png';
import Logo91 from './images/LOGO_draw_on-loop 2_00091.png';
import Logo92 from './images/LOGO_draw_on-loop 2_00092.png';
import Logo93 from './images/LOGO_draw_on-loop 2_00093.png';
import Logo94 from './images/LOGO_draw_on-loop 2_00094.png';
import Logo95 from './images/LOGO_draw_on-loop 2_00095.png';

export default [
  Logo1,
  Logo2,
  Logo3,
  Logo4,
  Logo5,
  Logo6,
  Logo7,
  Logo8,
  Logo9,
  Logo10,
  Logo11,
  Logo12,
  Logo13,
  Logo14,
  Logo15,
  Logo16,
  Logo17,
  Logo18,
  Logo19,
  Logo20,
  Logo21,
  Logo22,
  Logo23,
  Logo24,
  Logo25,
  Logo26,
  Logo27,
  Logo28,
  Logo29,
  Logo30,
  Logo31,
  Logo32,
  Logo33,
  Logo34,
  Logo35,
  Logo36,
  Logo37,
  Logo38,
  Logo39,
  Logo40,
  Logo41,
  Logo42,
  Logo43,
  Logo44,
  Logo45,
  Logo46,
  Logo47,
  Logo48,
  Logo49,
  Logo50,
  Logo51,
  Logo52,
  Logo53,
  Logo54,
  Logo55,
  Logo56,
  Logo57,
  Logo58,
  Logo59,
  Logo60,
  Logo61,
  Logo62,
  Logo63,
  Logo64,
  Logo65,
  Logo66,
  Logo67,
  Logo68,
  Logo69,
  Logo70,
  Logo71,
  Logo72,
  Logo73,
  Logo74,
  Logo75,
  Logo76,
  Logo77,
  Logo78,
  Logo79,
  Logo80,
  Logo81,
  Logo82,
  Logo83,
  Logo84,
  Logo85,
  Logo86,
  Logo87,
  Logo88,
  Logo89,
  Logo90,
  Logo91,
  Logo92,
  Logo93,
  Logo94,
  Logo95,
];
